import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import {
  If,
  ImageComponent,
  VideoPlayerComponent,
  WebinarInfoPanelComponent,
} from '../../../sharedLegacy/components'
import { alterTransparency } from '../../../sharedLegacy/utils'
import { ThankYouMessageComponent, WaitingRoomCountdownComponent } from '..'
import { useWebinarColors } from '../../../Designs/blocs/useWebinarColors'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'
import {
  useIsWebinarOver,
  useWaitingRoomType,
} from '../../useAudienceLiveState'

import './MediaWaitingRoomScreenComponent.scss'
import './MediaWaitingRoomScreenComponent.mobile.scss'

const renderMedia = (opts, liveData) => {
  const { waitingRoomType, isWebinarOver, isMobileDevice } = opts
  const prefix = isWebinarOver ? 'after' : 'before'

  if (waitingRoomType === 'image') {
    return (
      <ImageComponent
        className="image-cover"
        src={liveData[`${prefix}_webinar_photo_url`]}
      />
    )
  }

  return (
    <VideoPlayerComponent
      object={{
        photo_id: liveData[`${prefix}_webinar_photo_id`],
        token: liveData[`${prefix}_webinar_photo_token`],
      }}
      objectType="photo"
      options={{
        autoPlay: 1,
        mutedAutoPlay: 1,
        ...(isMobileDevice && { unmuteButtonPosition: 'rightTop' }),
        corePeopleDisabled: 0,
        source: 'webinarwaitingroom',
        showTray: 0,
        loop: 1,
        include_actions_p: 0,
      }}
    />
  )
}

const renderInfoPanel = () => (
  <WebinarInfoPanelComponent
    theme="waiting-room"
    style={{ color: '#FFFFFF' }}
  />
)

const getDecorationLineStyle = (isMobileDevice, accentColor) => {
  if (!isMobileDevice) {
    return { backgroundColor: accentColor }
  }

  return {
    background: `linear-gradient(-90deg, ${alterTransparency(
      accentColor,
      0
    )}, ${alterTransparency(accentColor, 1)})`,
  }
}

const MediaWaitingRoomScreenComponent = ({ isMobileDevice }) => {
  const { data: liveData } = useLiveDataQuery()
  const isWebinarOver = useIsWebinarOver()
  const waitingRoomType = useWaitingRoomType()
  const webinarColors = useWebinarColors()
  const accentColor = webinarColors.accent.color

  if (!liveData) {
    return null
  }

  const classes = classnames(
    `media-waiting-room-screen-component ${waitingRoomType}-room`,
    {
      'webinar-is-over': isWebinarOver,
    }
  )

  return (
    <div className={classes}>
      <div className="media">
        {renderMedia(
          { waitingRoomType, isWebinarOver, isMobileDevice },
          liveData
        )}
      </div>
      <div className="footer">
        <If condition={liveData.before_webinar_countdown_p && !isWebinarOver}>
          <WaitingRoomCountdownComponent />
        </If>
        <If condition={!isWebinarOver || !liveData.after_webinar_link}>
          <div
            className="decoration-line"
            style={getDecorationLineStyle(isMobileDevice, accentColor)}
          />
        </If>
        {isWebinarOver ? <ThankYouMessageComponent /> : renderInfoPanel()}
      </div>
    </div>
  )
}

MediaWaitingRoomScreenComponent.propTypes = {
  isMobileDevice: PropTypes.bool,
}

// eslint-disable-next-line import-x/no-default-export
export default MediaWaitingRoomScreenComponent
